import { Map, TileLayer as TileLayerEntity } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, ZoomControl } from 'react-leaflet';
import { DialogWaterLevel } from 'src/modules/map-dialog/components/DialogWaterLevel.component';
import { CheckBoxHrpnsNdGeoJSON } from 'src/modules/map-geo-jsons/components/CheckBoxHrpnsNdGeoJSON.component';
import { MAPBOX_TILE_LAYER_PROPS } from 'src/redux/slices/baseLayer.slice';
import { MapRiverDashboard } from './MapRiverDashboard.component';
import styles from './Leaftlet.module.css';
import { TileLayerControlBellow } from './TileLayerControlBellow.component';
import { TileLayerControlTopRight } from './TileLayerControlTopRight.component';
import { LeafletProps } from './types/leaflet-props.type';

export function Leaflet({ mapContainerProps }: LeafletProps) {
  const baseTileLayer = useRef<TileLayerEntity>(new TileLayerEntity(''));
  const map = useRef<Map>(null);

  useEffect(() => {
    const syncMapSize = () => {
      window.requestAnimationFrame(() => map.current?.invalidateSize());
      window.setTimeout(() => map.current?.invalidateSize(), 300);
    };

    window.addEventListener('map-layout-change', syncMapSize);
    return () => window.removeEventListener('map-layout-change', syncMapSize);
  }, []);

  return (
      <div className={styles.root}>
        <MapRiverDashboard />
        <div className={styles.mapPane}>
          <DialogWaterLevel />
          <MapContainer
            attributionControl={false}
            {...mapContainerProps}
            maxBoundsViscosity={1}
            zoomControl={false}
            className={styles.mapScope}
            style={{ ...mapContainerProps?.style, width: '100%' }}
            ref={map}>
            <TileLayer {...MAPBOX_TILE_LAYER_PROPS} ref={baseTileLayer} maxNativeZoom={18} />
            <ZoomControl position="bottomleft" />
            <TileLayerControlBellow />
            <CheckBoxHrpnsNdGeoJSON baseTileLayer={baseTileLayer} checked />
            <TileLayerControlTopRight baseTileLayer={baseTileLayer} map={map} />
          </MapContainer>
        </div>
      </div>
  );
}
